import { API } from "../api";
import axios from "axios";

const jsonHeaders = { "Content-Type": "application/json" };

export const authenticate = async (payload) => {
  try {
    if (!payload.email || !payload.password) {
      throw new Error("Email y contraseña son requeridos");
    }

    const { data } = await axios.post(`${API.DEV}/auth`, payload, {
      headers: jsonHeaders,
    });

    if (data.token) {
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));
      
      axios.defaults.headers.common["Authorization"] = `Bearer ${data.token}`;
    }

    return data;
  } catch (err) {
    console.error("Error en autenticación:", err);
    if (err.response?.data) {
      return err.response.data;
    }
    throw new Error(err.message || "Error en autenticación");
  }
};

export const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  delete axios.defaults.headers.common["Authorization"];
};

export const registerUser = async (payload) => {
  try {
    const { data } = await axios.post(`${API.DEV}/user/create`, payload, {
      headers: jsonHeaders,
    });
    return data;
  } catch (err) {
    console.log(err);
    if (err.response?.data) return err.response.data;
    throw new Error(err);
  }
};

export const findMechanics = async () => {
  try {
    const { data } = await axios.get(`${API.DEV}/user/mechanics`);
    return data;
  } catch (err) {
    throw new Error(err);
  }
};

export const findAllUsers = async () => {
  try {
    const { data } = await axios.get(`${API.DEV}/user/list`);
    return data;
  } catch (err) {
    throw new Error(err);
  }
};

export const deleteUser = async (id) => {
  try {
    const { data } = await axios.get(`${API.DEV}/user/delete/${id}`);
    return data;
  } catch (err) {
    throw new Error(err);
  }
};

export const updateUser = async (payload, id) => {
  try {
    const { data } = await axios.post(`${API.DEV}/user/update/${id}`, payload, {
      headers: jsonHeaders,
    });
    return data;
  } catch (err) {
    throw new Error(err);
  }
};

export const findUserById = async (id) => {
  try {
    const { data } = await axios.get(`${API.DEV}/user/find/${id}`);
    return data;
  } catch (err) {
    throw new Error(err);
  }
};

export const initializeAuth = () => {
  const token = localStorage.getItem("token");
  if (token) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  }

  // Belt-and-suspenders: also install a request interceptor so that even if
  // axios.defaults gets wiped (HMR, logout/login races, third-party libs that
  // clone axios config) the Authorization header is always attached from the
  // current localStorage token.
  axios.interceptors.request.use((config) => {
    const t = localStorage.getItem("token");
    if (t) {
      config.headers = config.headers || {};
      if (!config.headers["Authorization"] && !config.headers["authorization"]) {
        config.headers["Authorization"] = `Bearer ${t}`;
      }
    }
    return config;
  });
};
